module.exports = __webpack_public_path__ + "img/bg-lucky-draw-list-none.415aec35.png";